import Enums from "../../enums/enums";
import merchantHelper from "../../helper/merchantHelper";

function GetSettingTransactionDueDate(settingTransactionDueDateRawList) {
  let _settingTransactionDueDate = [];
  if (settingTransactionDueDateRawList && settingTransactionDueDateRawList.length > 0) {
    for (var settingTransactionDueDateRaw of settingTransactionDueDateRawList) {
      _settingTransactionDueDate.push({
        transactionType: settingTransactionDueDateRaw.transactionType,
        financeType: settingTransactionDueDateRaw.financeType,
        transactionItemType: settingTransactionDueDateRaw.transactionItemType,
        day: settingTransactionDueDateRaw.day,
        settingDueDateType: settingTransactionDueDateRaw.settingDueDateType,
      });
    }
  }
  return _settingTransactionDueDate;
}
function GetSettingTransactionRemark(settingTransactionRemarkRawList) {
  let _settingTransactionRemark = [];
  if (settingTransactionRemarkRawList && settingTransactionRemarkRawList.length > 0) {
    for (var settingTransactionRemarkRaw of settingTransactionRemarkRawList) {
      _settingTransactionRemark.push({
        transactionType: settingTransactionRemarkRaw.transactionType,
        financeType: settingTransactionRemarkRaw.financeType,
        transactionItemType: settingTransactionRemarkRaw.transactionItemType,
        remark: settingTransactionRemarkRaw.remark,
      });
    }
  }
  return _settingTransactionRemark;
}

function GetSettingTransactionNumber(settingTransactionNumberRawList) {
  let _settingTransactionNumber = [];
  if (settingTransactionNumberRawList && settingTransactionNumberRawList.length > 0) {
    for (var settingTransactionNumberRaw of settingTransactionNumberRawList) {
      _settingTransactionNumber.push({
        headerTransactionType: settingTransactionNumberRaw.headerTransactionType,
        financeType: settingTransactionNumberRaw.financeType,
        indexString: settingTransactionNumberRaw.indexString,
        symbol: settingTransactionNumberRaw.symbol,
        formatDate: settingTransactionNumberRaw.formatDate,
        yearType: settingTransactionNumberRaw.yearType,
        amountRunningNumber: settingTransactionNumberRaw.amountRunningNumber,
        isTransactionNumberDefault: settingTransactionNumberRaw.isTransactionNumberDefault,
      });
    }
  }
  return _settingTransactionNumber;
}

function GetMerchantDetail(_settingMerchantDetail) {
  let settingMerchantDetail = {
    addressList: _settingMerchantDetail.addressList,
    building: _settingMerchantDetail.building,
    businessCategoryId: _settingMerchantDetail.businessCategoryId,
    country: _settingMerchantDetail.country,
    description: _settingMerchantDetail.description,
    district1: _settingMerchantDetail.district1,
    district2: _settingMerchantDetail.district2,
    email: _settingMerchantDetail.email,
    alternativeEmail: _settingMerchantDetail.alternativeEmail,
    expireDateTime: _settingMerchantDetail.expireDateTime,
    facebook: _settingMerchantDetail.facebook,
    fax: _settingMerchantDetail.fax,
    floorNo: _settingMerchantDetail.floorNo,
    homeGroup: _settingMerchantDetail.homeGroup,
    homeno: _settingMerchantDetail.homeno,
    industryCode: _settingMerchantDetail.industryCode,
    isAccountingFirm: _settingMerchantDetail.isAccountingFirm,
    isAllowDuplicateContact: _settingMerchantDetail.isAllowDuplicateContact,
    isAllowDuplicateProduct: _settingMerchantDetail.isAllowDuplicateProduct,
    isAutoApprove: _settingMerchantDetail.isAutoApprove,
    isLockPeriod: _settingMerchantDetail.isLockPeriod,
    isSample: _settingMerchantDetail.isSample,
    isSeparateRunningCreditNoteExpenseTaxInvoiceNumber:
      _settingMerchantDetail.isSeparateRunningCreditNoteExpenseTaxInvoiceNumber ? true : false,
    isSeparateRunningCreditNoteTaxInvoiceNumber: _settingMerchantDetail.isSeparateRunningCreditNoteTaxInvoiceNumber
      ? true
      : false,
    isSeparateRunningInvoiceTaxInvoiceNumber: _settingMerchantDetail.isSeparateRunningInvoiceTaxInvoiceNumber
      ? true
      : false,
    isSeparateRunningReceiptTaxInvoiceNumber: _settingMerchantDetail.isSeparateRunningReceiptTaxInvoiceNumber
      ? true
      : false,
    isSeparateRunningDebitNoteTaxInvoiceNumber: _settingMerchantDetail.isSeparateRunningDebitNoteTaxInvoiceNumber
      ? true
      : false,
    isSeparateRunningPuchaseOrderAssetNumber: _settingMerchantDetail.isSeparateRunningPuchaseOrderAssetNumber
      ? true
      : false,
    isSeparateRunningDepositTaxInvoiceNumber: _settingMerchantDetail.isSeparateRunningDepositTaxInvoiceNumber
      ? true
      : false,
    isVat: _settingMerchantDetail.isVat,
    lineId: _settingMerchantDetail.lineId,
    lockPeriodEndDate: _settingMerchantDetail.lockPeriodEndDate,
    logoUrl: _settingMerchantDetail.logoUrl
      ? process.env.VUE_APP_PeakBlobStorage.UrlCombine(
          "peakengine",
          `${_settingMerchantDetail.logoUrl}?${new Date().getTime()}`
        )
      : "",
    merchantBranchCode: _settingMerchantDetail.merchantBranchCode,
    merchantId: _settingMerchantDetail.merchantId,
    merchantName: _settingMerchantDetail.merchantName,
    merchantNameEng: _settingMerchantDetail.merchantNameEng,
    merchantNameTh: _settingMerchantDetail.merchantNameTh,
    merchantTaxId: _settingMerchantDetail.merchantTaxId,
    merchantType: _settingMerchantDetail.merchantType,
    no: _settingMerchantDetail.no,
    package: _settingMerchantDetail.package,
    payrollContactId: _settingMerchantDetail.payrollContactId,
    phone: _settingMerchantDetail.phone,
    postCode: _settingMerchantDetail.postCode,
    province: _settingMerchantDetail.province,
    registeredDate: _settingMerchantDetail.registeredDate,
    revenueDepartmentContactId: _settingMerchantDetail.revenueDepartmentContactId,
    road: _settingMerchantDetail.road,
    roomNo: _settingMerchantDetail.roomNo,
    sendBranch: _settingMerchantDetail.sendBranch,
    sendBuilding: _settingMerchantDetail.sendBuilding,
    sendCountry: _settingMerchantDetail.sendCountry,
    sendDistrict1: _settingMerchantDetail.sendDistrict1,
    sendDistrict2: _settingMerchantDetail.sendDistrict2,
    sendFloorNo: _settingMerchantDetail.sendFloorNo,
    sendHomeGroup: _settingMerchantDetail.sendHomeGroup,
    sendHomeNo: _settingMerchantDetail.sendHomeNo,
    sendNo: _settingMerchantDetail.sendNo,
    sendPostcode: _settingMerchantDetail.sendPostcode,
    sendProvince: _settingMerchantDetail.sendProvince,
    sendRoad: _settingMerchantDetail.sendRoad,
    sendRoomNo: _settingMerchantDetail.sendRoomNo,
    sendSoi: _settingMerchantDetail.sendSoi,
    soi: _settingMerchantDetail.soi,
    ssoContactId: _settingMerchantDetail.ssoContactId,
    stampUrl: _settingMerchantDetail.stampUrl
      ? process.env.VUE_APP_PeakBlobStorage.UrlCombine(
          "peakengine",
          `${_settingMerchantDetail.stampUrl}?${new Date().getTime()}`
        )
      : "",
    status: _settingMerchantDetail.status,
    taxStatusType: _settingMerchantDetail.taxStatusType,
    vatRegistrationDate: _settingMerchantDetail.vatRegistrationDate,
    verifiedDatetime: _settingMerchantDetail.verifiedDatetime,
    website: _settingMerchantDetail.website,
    verificationStatus: _settingMerchantDetail.verificationStatus,
    isDeleted: _settingMerchantDetail.isDeleted,
    uniqueTransactionNumberType: _settingMerchantDetail.uniqueTransactionNumberType,
  };
  return settingMerchantDetail;
}
function GetMerchantAddressList(settingMerchantAddressList) {
  let settingMerchantAddressListCopy = [];

  for (let settingMerchantAddress of settingMerchantAddressList) {
    settingMerchantAddressListCopy.push({
      id: settingMerchantAddress.id,
      name: settingMerchantAddress.name,
      building: settingMerchantAddress.building,
      roomNo: settingMerchantAddress.roomNo,
      floorNo: settingMerchantAddress.floorNo,
      no: settingMerchantAddress.no,
      homeGroup: settingMerchantAddress.homeGroup,
      homeNo: settingMerchantAddress.homeNo,
      soi: settingMerchantAddress.soi,
      road: settingMerchantAddress.road,
      district1: settingMerchantAddress.district1,
      district2: settingMerchantAddress.district2,
      province: settingMerchantAddress.province,
      country: settingMerchantAddress.country,
      postCode: settingMerchantAddress.postCode,
      addressName: settingMerchantAddress.addressName,
      language: settingMerchantAddress.language,
    });
  }
  return settingMerchantAddressListCopy;
}
function DoGetUserRoleDetailByUserId(_userDetail) {
  let userDetail = {
    userId: _userDetail.userId,
    email: _userDetail.email,
    firstName: _userDetail.firstName,
    lastName: _userDetail.lastName,
    phone: _userDetail.phone,
    merchantUserRoleType: _userDetail.merchantUserRoleType,
    manageUser: _userDetail.manageUser,
    manageFinance: _userDetail.manageFinance,
    isSuperUser: _userDetail.isSuperUser,
    isSeeSelfDocuments: _userDetail.isSeeSelfDocuments,
    isUsePayroll: _userDetail.isUsePayroll,
    isUsePeakBoard: _userDetail.isUsePeakBoard,
    manageProduct: _userDetail.manageProduct,
    userRoleModel: _userDetail.userRoleModel,
    authorityRole: _userDetail.authorityRole,
    manageAsset: _userDetail.manageAsset,
    manageContact: _userDetail.manageContact,
    isViewReport: _userDetail.userRoleModel.role2,
  };
  return userDetail;
}
function GetMerchantSettingApiPartnerUserToken(_apiPartnerUserToken) {
  let apiPartnerUserToken = [];
  for (let partnerUserToken of _apiPartnerUserToken) {
    let apiPartnerType = partnerUserToken.apiPartnerType;
    let userTokenList = [];
    for (let userToken of partnerUserToken.userTokenList) {
      userTokenList.push({
        userTokenId: userToken.userTokenId,
        userToken: userToken.userToken,
        userId: userToken.userId,
        createDateTime: userToken.createDateTime,
      });
    }
    apiPartnerUserToken.push({
      apiPartnerType: apiPartnerType,
      userTokenList: userTokenList,
    });
  }
  return apiPartnerUserToken;
}
function GetOnlineViewPublicFormatSetting(_getOnlineViewPublicFormatSetting) {
  let getOnlineViewPublicFormatSetting = {
    isShowSignatureOnPublicLink: _getOnlineViewPublicFormatSetting.isShowSignatureOnPublicLink,
    isShowStampOnPublicLink: _getOnlineViewPublicFormatSetting.isShowStampOnPublicLink,
    isUsePassCodeOnPublicLink: _getOnlineViewPublicFormatSetting.isUsePassCodeOnPublicLink,
  };
  return getOnlineViewPublicFormatSetting;
}
function ConvertToETaxConnectSetting(_eTaxConnectSetting) {
  let eTaxConnectSetting = {
    eTaxConnectType: _eTaxConnectSetting.eTaxConnectType,
    invoiceOnlineViewType: {
      value: _eTaxConnectSetting.invoiceOnlineViewType,
    },
    receiptOnlineViewType: {
      value: _eTaxConnectSetting.receiptOnlineViewType,
    },
    taxInvoiceOnlineViewType: {
      value: _eTaxConnectSetting.taxInvoiceOnlineViewType,
    },
  };
  return eTaxConnectSetting;
}

function ConvertToOnboardingLog(_onboardingLog) {
  let onboardingLog = {
    merchantId: _onboardingLog.merchantId,
    userId: _onboardingLog.userId,
    isAlreadyViewOnboarding: _onboardingLog.isAlreadyViewOnboarding,
    isSendRequestConsult: _onboardingLog.isSendRequestConsult,
    sendRequestConsultLog: _onboardingLog.sendRequestConsultLog,
    viewOnboardingLog: _onboardingLog.viewOnboardingLog,
  };
  return onboardingLog;
}

function ConvertToUserTemplateModel(userTemplate) {
  let userTemplateModel = {
    id: userTemplate.id,
    firstName: userTemplate.firstName.value,
    lastName: userTemplate.lastName.value,
    phone: userTemplate.phone.value,
    departmentId: userTemplate.department.value.value >= 0 ? userTemplate.department.value.value : null,
    departmentOther: userTemplate.departmentOther.value,
    positionId: userTemplate.position.value.value >= 0 ? userTemplate.position.value.value : null,
    positionOther: userTemplate.positionOther.value,
    birthDate:
      userTemplate.birthdate.value && !isNaN(new Date(userTemplate.birthdate.value).getTime())
        ? userTemplate.birthdate.value.ToDateJsonString()
        : null,
    pictureImg: {
      fileName: userTemplate.pictureImg.fileName,
      fileType: userTemplate.pictureImg.fileType,
      rawString: userTemplate.pictureImg.rawString,
      urlImg: userTemplate.pictureImg.urlImg,
    },
    signatureImg: {
      fileName: userTemplate.signatureImg.fileName,
      fileType: userTemplate.signatureImg.fileType,
      rawString: userTemplate.signatureImg.rawString,
      urlImg: userTemplate.signatureImg.urlImg,
    },
    isUpdatePictureImg: userTemplate.isUpdatePictureImg,
    isUpdateSignatureImg: userTemplate.isUpdateSignatureImg,
  };
  return userTemplateModel;
}
function ConvertToTokenDataPage365(tokenData) {
  let tokenDataModel;
  if (tokenData) {
    tokenDataModel = {
      merchantToken: tokenData.merchantToken ? tokenData.merchantToken : "",
      userId: tokenData.userId ? tokenData.userId : 0,
      page365ConfigData: tokenData.page365ConfigData,
    };
  }
  return tokenDataModel;
}
function ConvertToTokenConfigDataPage365(configToken) {
  let configTokenModel = null;

  if (configToken) {
    configTokenModel = {
      parentAccount: {
        id: configToken.parentAccountId,
      },
      promotionAccount: {
        id: configToken.promotionAccountId > 0 ? configToken.promotionAccountId : 91,
      },
      shippingAccount: {
        id: configToken.shippingAccountId > 0 ? configToken.shippingAccountId : 98,
      },
      creditNoteType: {
        id:
          configToken.suspectCreditNoteAccountId > 0
            ? Enums.CreditNoteTypeOption.CreditedToAccountCode
            : Enums.CreditNoteTypeOption.CreditedToReceivedBankAccount,
      },
      creditNoteAccount: {
        id: configToken.suspectCreditNoteAccountId ? configToken.suspectCreditNoteAccountId : 354,
      },
      page365PaymentList: [],
    };

    if (configToken.page365PaymentData && configToken.page365PaymentData.length > 0) {
      configToken.page365PaymentData.forEach((item) => {
        configTokenModel.page365PaymentList.push({
          bankAccount: {
            bankAccountId: item.bankAccountId ? item.bankAccountId : 0,
            inputValidationError: false,
          },
          page365BankAccountId: item.page365BankAccountId,
          page365BankAccountName: item.page365BankAccountName,
          page365BankAccountNo: item.page365BankAccountNo,
          page365BankAccountSlug: item.page365BankAccountSlug,
          page365BankAccountFullName:
            item.page365BankAccountSlug === "cod"
              ? "COD"
              : item.page365BankAccountSlug + " - " + item.page365BankAccountName,
        });
      });
    }
  }

  return configTokenModel;
}
function SetBentoWebPaymentTitleName(bentoWebPayment) {
  let bentoWebPaymentName = "";
  switch (bentoWebPayment.bentoWebPaymentKeyType) {
    case Enums.BentoWebPaymentKeyType.PaymentMethod:
      bentoWebPaymentName = bentoWebPayment.bentoWebPaymentMethod.bentoWebPaymentName;
      break;
    case Enums.BentoWebPaymentKeyType.Bank:
      bentoWebPaymentName = bentoWebPayment.bentoWebPaymentBank.bentoWebPaymentName;
      break;
    case Enums.BentoWebPaymentKeyType.Shipping:
      bentoWebPaymentName = bentoWebPayment.bentoWebPaymentShipping.bentoWebPaymentShippingName
        ? bentoWebPayment.bentoWebPaymentShipping.bentoWebPaymentName +
          " " +
          bentoWebPayment.bentoWebPaymentShipping.bentoWebPaymentShippingName
        : bentoWebPayment.bentoWebPaymentShipping.bentoWebPaymentName;
      break;
  }

  return bentoWebPaymentName;
}
function ConvertToTokenDataBentoWeb(tokenData) {
  let tokenDataModel = null;

  if (tokenData) {
    tokenDataModel = {
      clientId: tokenData.clientId,
      createDateTime: tokenData.createDateTime,
      isDeleted: tokenData.isDeleted,
      secretKey: tokenData.secretKey,
      storeId: tokenData.storeId,
      userId: tokenData.userId,
      bentoWebAccessData: {
        accessToken: tokenData.bentoWebAccessData.accessToken,
        expiredDateTime: tokenData.bentoWebAccessData.expiredDateTime,
        expiresIn: tokenData.bentoWebAccessData.expiresIn,
        refreshToken: tokenData.bentoWebAccessData.refreshToken,
      },
      bentoWebConfigData: tokenData.bentoWebConfigData,
    };
  }

  return tokenDataModel;
}
function ConvertToTokenConfigDataBentoWeb(configTokenData) {
  let configTokenDataModel = {
    createDateTime: configTokenData.createDateTime,
    isCreateLazadaOrder: configTokenData.isCreateLazadaOrder,
    isCreateShopeeOrder: configTokenData.isCreateShopeeOrder,
    paymentAccount: {
      id: configTokenData.paymentAccountId > 0 ? configTokenData.paymentAccountId : 98,
    },
    revenueBasisType: {
      id:
        configTokenData.revenueBasisType > 0
          ? configTokenData.revenueBasisType
          : Enums.BentoWebRevenueBasisType.AccrualBasis,
    },
    shippingVatType: {
      id: configTokenData.shippingVatType > 0 ? configTokenData.shippingVatType : Enums.ShippingVatType.None,
    },
    promotionAccount: {
      id: configTokenData.promotionAccountId > 0 ? configTokenData.promotionAccountId : 91,
    },
    shippingAccount: {
      id: configTokenData.shippingAccountId > 0 ? configTokenData.shippingAccountId : 98,
    },
    creditNoteType: {
      id:
        configTokenData.suspenseCreditNoteAccountId > 0
          ? Enums.CreditNoteTypeOption.CreditedToAccountCode
          : Enums.CreditNoteTypeOption.CreditedToReceivedBankAccount,
    },
    creditNoteAccount: {
      id: configTokenData.suspenseCreditNoteAccountId ? configTokenData.suspenseCreditNoteAccountId : 354,
    },
    bentoWebPaymentList: [],
  };

  if (configTokenData.bentoWebPaymentData && configTokenData.bentoWebPaymentData.length > 0) {
    configTokenData.bentoWebPaymentData.forEach((item) => {
      configTokenDataModel.bentoWebPaymentList.push({
        bankAccount: {
          bankAccountId: item.bankAccountId ? item.bankAccountId : 0,
          inputValidationError: false,
        },
        bentoWebPaymentBank: item.bentoWebPaymentBank,
        bentoWebPaymentKey: item.bentoWebPaymentKey,
        bentoWebPaymentKeyType: item.bentoWebPaymentKeyType,
        bentoWebPaymentShipping: item.bentoWebPaymentShipping,
        bentoWebPaymentName: item.bentoWebPaymentMethod,
        bentoWebPaymentTitleName: SetBentoWebPaymentTitleName(item),
      });
    });
  }

  return configTokenDataModel;
}
function ConvertToTokenConfigDataPage365Request(configToken) {
  const configModel = {
    shippingAccountId: configToken.shippingAccount.id,
    parentAccountId: configToken.parentAccount.id,
    suspectCreditNoteAccountId:
      configToken.creditNoteType.id === Enums.CreditNoteTypeOption.CreditedToReceivedBankAccount
        ? 0
        : configToken.creditNoteAccount.id,
    promotionAccountId: configToken.promotionAccount.id,
    page365PaymentData: [],
  };

  if (configToken.page365PaymentList && configToken.page365PaymentList.length > 0) {
    configToken.page365PaymentList.forEach((item) => {
      configModel.page365PaymentData.push({
        bankAccountId: item.bankAccount.bankAccountId,
        page365BankAccountId: item.page365BankAccountId,
        page365BankAccountNo: item.page365BankAccountNo,
        page365BankAccountName: item.page365BankAccountName,
        page365BankAccountSlug: item.page365BankAccountSlug,
      });
    });
  }

  return configModel;
}
function ConvertToBentoWebUpdateConfigData(tokenConfigData) {
  const tokenConfigDataModel = {
    shippingAccountId: tokenConfigData.shippingAccount.id,
    shippingVatType: tokenConfigData.shippingVatType.id,
    isCreateLazadaOrder: tokenConfigData.isCreateLazadaOrder,
    isCreateShopeeOrder: tokenConfigData.isCreateShopeeOrder,
    paymentAccountId: tokenConfigData.paymentAccount.id,
    suspenseCreditNoteAccountId: tokenConfigData.creditNoteAccount.id,
    promotionAccountId: tokenConfigData.promotionAccount.id,
    revenueBasisType: tokenConfigData.revenueBasisType.id,
    BentoWebPaymentData: [],
  };

  if (tokenConfigData.bentoWebPaymentList && tokenConfigData.bentoWebPaymentList.length > 0) {
    tokenConfigData.bentoWebPaymentList.forEach((item) => {
      tokenConfigDataModel.BentoWebPaymentData.push({
        bankAccountId: item.bankAccount.bankAccountId,
        bentoWebPaymentKey: item.bentoWebPaymentKey,
        bentoWebPaymentKeyType: item.bentoWebPaymentKeyType,
        bentoWebPaymentMethod: item.bentoWebPaymentName,
        bentoWebPaymentShipping: item.bentoWebPaymentShipping,
        bentoWebPaymentBank: item.bentoWebPaymentBank,
      });
    });
  }

  return tokenConfigDataModel;
}
function ConvertToTokenDataLineMyShop(tokenData) {
  let tokenDataModel = null;

  if (tokenData) {
    tokenDataModel = {
      userId: tokenData.userId,
      accessToken: tokenData.accessToken,
      webhookUrl: tokenData.webhookUrl,
      lineMyShopConfigData: tokenData.lineMyShopConfigData,
    };
  }

  return tokenDataModel;
}
function ConvertToTokenConfigDataLineMyShop(configTokenData, contact) {
  let configTokenDataModel = {
    contact: contact
      ? contact
      : {
          id: 0,
          contactCode: "",
          validateError: false,
        },
    promotionAccount: {
      id: configTokenData.promotionAccountId > 0 ? configTokenData.promotionAccountId : 91,
    },
    shippingAccount: {
      id: configTokenData.shippingAccountId > 0 ? configTokenData.shippingAccountId : 98,
    },
    lineMyShopPaymentList: [],
  };

  if (configTokenData.lineMyShopPaymentData && configTokenData.lineMyShopPaymentData.length > 0) {
    configTokenData.lineMyShopPaymentData.forEach((item) => {
      configTokenDataModel.lineMyShopPaymentList.push({
        bankAccount: {
          bankAccountId: item.bankAccountId ? item.bankAccountId : 0,
          inputValidationError: false,
        },
        lineMyShopBankAccountName: item.lineMyShopBankAccountName,
        lineMyShopBankAccountSlug: item.lineMyShopBankAccountSlug,
      });
    });
  }

  return configTokenDataModel;
}
function ConvertToLineMyShopUpdateConfigData(tokenConfigData) {
  const tokenConfigDataModel = {
    shippingAccountId: tokenConfigData.shippingAccount.id,
    promotionAccountId: tokenConfigData.promotionAccount.id,
    peakContactId: tokenConfigData.contact.id,
    lineMyShopPaymentData: [],
  };

  if (tokenConfigData.lineMyShopPaymentList && tokenConfigData.lineMyShopPaymentList.length > 0) {
    tokenConfigData.lineMyShopPaymentList.forEach((item) => {
      tokenConfigDataModel.lineMyShopPaymentData.push({
        bankAccountId: item.bankAccount.bankAccountId,
        lineMyShopBankAccountName: item.lineMyShopBankAccountName,
        lineMyShopBankAccountSlug: item.lineMyShopBankAccountSlug,
      });
    });
  }

  return tokenConfigDataModel;
}
function ConvertToTokenDataShopee(tokenData) {
  let tokenDataModel = [];

  if (tokenData && tokenData.length > 0) {
    tokenData.forEach((item) => {
      tokenDataModel.push({
        createDateTime: item.createDateTime,
        userId: item.userId,
        shopId: item.shopId,
        shopeeStoreData: item.shopeeStoreData,
        shopeeConfigData: item.shopeeConfigData,
      });
    });
  }

  return tokenDataModel;
}
function ConvertToTokenDataLazada(tokenData) {
  let tokenDataModel = [];
  if (tokenData && tokenData.length > 0) {
    tokenData.forEach((item) => {
      tokenDataModel.push({
        createDateTime: item.createDateTime,
        userId: item.userId,
        sellerId: item.sellerId,
        shopName: item.lazadaStoreData ? item.lazadaStoreData.account : "n/a",
        lazadaConfigData: item.lazadaConfigData,
        lazadaStoreData: item.lazadaStoreData,
      });
    });
  }

  return tokenDataModel;
}
function ConvertToTokenDataTiktok(tokenData) {
  let tokenDataModel = [];
  if (tokenData && tokenData.length > 0) {
    tokenData.forEach((item) => {
      tokenDataModel.push({
        createDateTime: item.createDateTime,
        userId: item.userId,
        sellerId: item.sellerId,
        shopName: item.tiktokStoreData ? item.tiktokStoreData.account : "n/a",
        tiktokConfigData: item.tiktokConfigData,
        tiktokStoreData: item.tiktokStoreData,
      });
    });
  }

  return tokenDataModel;
}
function ConvertToClientUserDataAPIOwnUse(clientUserData) {
  let clientUserDataModel = [];
  if (clientUserData && clientUserData.length > 0) {
    clientUserData.forEach((item) => {
      let tokenList = [];
      if (item.userTokenList && item.userTokenList.length > 0) {
        item.userTokenList.forEach((token) => {
          tokenList.push({
            userId: token.userId,
            userToken: token.userToken,
            userTokenId: token.userTokenId,
            createDateTime: token.createDateTime,
          });
        });
      }
      clientUserDataModel.push({
        clientUserId: item.clientUserId,
        clientCode: item.clientCode,
        clientName: item.clientName,
        clientType: item.clientType,
        userTokenList: tokenList,
      });
    });
  }

  return clientUserDataModel;
}
function ConvertToPartnerUserTokenTable(userTokenData) {
  let partnerUserTokenTableModel = [];
  if (userTokenData && userTokenData.length > 0) {
    userTokenData.forEach((item) => {
      partnerUserTokenTableModel.push({
        apiCount: item.apiCount,
        billingCount: item.billingCount,
        report: item.report,
        token: item.tokenSuffix,
        tokenId: item.tokenId,
        shownGraph: true,
        userId: item.userId,
      });
    });
  }

  return partnerUserTokenTableModel;
}
function ConvertToPartnerUserTokenMonitor(userTokenMonitorData) {
  let partnerUserTokenMonitorModel = [];
  if (userTokenMonitorData && userTokenMonitorData.length > 0) {
    userTokenMonitorData.forEach((item) => {
      partnerUserTokenMonitorModel.push({
        apiCount: item.apiCount,
        billingCount: item.billingCount,
        item: item.item,
        token: item.tokenSuffix,
        tokenId: item.tokenId,
        shownGraph: true,
        userId: item.userId,
      });
    });
  }

  return partnerUserTokenMonitorModel;
}
function ConvertToValidateClientUserAPIOwnUse(validateClientUser) {
  let validateClientUserModel = {
    clientUserId: validateClientUser.clientUserId,
    clientName: validateClientUser.clientName,
    isActive: validateClientUser.isActive,
    isHaveUserToken: validateClientUser.isHaveUserToken,
  };

  return validateClientUserModel;
}
function ConvertToTokenConfigDataShopee(configTokenData, contact) {
  let configTokenDataModel = {
    shopId: 0,
    allocationItemId: configTokenData.allocationItemId > 0 ? [{ id: configTokenData.allocationItemId }] : [],
    documentNumberConfigType:
      configTokenData.documentNumberConfigType === 0
        ? Enums.DocumentNumberConfigType.Peak
        : configTokenData.documentNumberConfigType,
    contact: contact
      ? contact
      : {
          id: 0,
          contactCode: "",
          validateError: false,
        },
    promotionAccount: {
      id: configTokenData.promotionAccountId > 0 ? configTokenData.promotionAccountId : 91,
    },
    productAccount: {
      id: configTokenData.productAccountId > 0 ? configTokenData.productAccountId : 88,
    },
    isConnectPeak:
      configTokenData.productAccountId === 0
        ? true
        : configTokenData.productConfigType === Enums.ProductConfigType.None
        ? false
        : true,
    isSkuActive: false,
    productConfigType: {
      id:
        configTokenData.productAccountId === 0
          ? Enums.ProductConfigType.ProductCode
          : configTokenData.productConfigType,
    },
    shippingAccount: {
      id: configTokenData.shippingAccountId > 0 ? configTokenData.shippingAccountId : 98,
    },
    shippingVatType: {
      id: configTokenData.shippingVatType ? configTokenData.shippingVatType : Enums.ProductVatType.None,
    },
    shopeePaymentList: [],
    triggerOrderStatus: configTokenData.triggerOrderStatus,
  };

  if (configTokenData.shopeePaymentData && configTokenData.shopeePaymentData.length > 0) {
    configTokenData.shopeePaymentData.forEach((item) => {
      configTokenDataModel.shopeePaymentList.push({
        bankAccount: {
          bankAccountId: item.bankAccountId ? item.bankAccountId : 0,
          inputValidationError: false,
        },
        shopeePaymentMethod: item.shopeePaymentMethod ? item.shopeePaymentMethod : "-",
      });
    });
  }

  return configTokenDataModel;
}
function ConvertToTokenConfigDataLazada(configTokenData, contact) {
  let configTokenDataModel = {
    allocationItemId: configTokenData.allocationItemId > 0 ? [{ id: configTokenData.allocationItemId }] : [],
    documentNumberConfigType:
      configTokenData.documentNumberConfigType === 0
        ? Enums.DocumentNumberConfigType.Peak
        : configTokenData.documentNumberConfigType,
    contact: contact
      ? contact
      : {
          id: 0,
          contactCode: "",
          validateError: false,
        },
    promotionAccount: {
      id: configTokenData.promotionAccountId > 0 ? configTokenData.promotionAccountId : 91,
    },
    shippingAccount: {
      id: configTokenData.shippingAccountId > 0 ? configTokenData.shippingAccountId : contact ? 0 : 98,
    },
    shippingVatType: {
      id: configTokenData.shippingVatType ? configTokenData.shippingVatType : Enums.ProductVatType.None,
    },
    productAccount: {
      id: configTokenData.productAccountId > 0 ? configTokenData.productAccountId : 88,
    },
    isConnectPeak:
      configTokenData.productAccountId === 0
        ? true
        : configTokenData.productConfigType === Enums.ProductConfigType.None
        ? false
        : true,
    isSkuActive: false,
    isShippeeFeeSetting: configTokenData.shippingAccountId > 0 ? true : contact ? false : true,
    productConfigType: {
      id:
        configTokenData.productAccountId === 0
          ? Enums.ProductConfigType.ProductCode
          : configTokenData.productConfigType,
    },
    lazadaPaymentList: [],
    triggerOrderStatus: configTokenData.triggerOrderStatus ?? 0,
  };

  if (configTokenData.lazadaPaymentData && configTokenData.lazadaPaymentData.length > 0) {
    configTokenData.lazadaPaymentData.forEach((item) => {
      configTokenDataModel.lazadaPaymentList.push({
        bankAccount: {
          bankAccountId: item.bankAccountId ? item.bankAccountId : 0,
          inputValidationError: false,
        },
        lazadaPaymentMethod: item.lazadaPaymentMethod ? item.lazadaPaymentMethod : "-",
      });
    });
  }

  return configTokenDataModel;
}
function ConvertToTokenConfigDataTiktok(configTokenData, contact) {
  let configTokenDataModel = {
    allocationItemId: configTokenData.allocationItemId > 0 ? [{ id: configTokenData.allocationItemId }] : [],
    documentNumberConfigType:
      configTokenData.documentNumberConfigType === 0
        ? Enums.DocumentNumberConfigType.Peak
        : configTokenData.documentNumberConfigType,
    contact: contact
      ? contact
      : {
          id: 0,
          contactCode: "",
          validateError: false,
        },
    promotionAccount: {
      id: configTokenData.promotionAccountId > 0 ? configTokenData.promotionAccountId : 91,
    },
    shippingAccount: {
      id: configTokenData.shippingAccountId > 0 ? configTokenData.shippingAccountId : contact ? 0 : 98,
    },
    shippingVatType: {
      id: configTokenData.shippingVatType ? configTokenData.shippingVatType : Enums.ProductVatType.None,
    },
    productAccount: {
      id: configTokenData.productAccountId > 0 ? configTokenData.productAccountId : 88,
    },
    isConnectPeak:
      configTokenData.productAccountId === 0
        ? true
        : configTokenData.productConfigType === Enums.ProductConfigType.None
        ? false
        : true,
    isSkuActive: false,
    isShippeeFeeSetting: configTokenData.shippingAccountId > 0 ? true : contact ? false : true,
    productConfigType: {
      id:
        configTokenData.productAccountId === 0
          ? Enums.ProductConfigType.ProductCode
          : configTokenData.productConfigType,
    },
    tiktokPaymentList: [],
    triggerOrderStatus: configTokenData.triggerOrderStatus ?? 0,
  };

  if (configTokenData.tiktokPaymentData && configTokenData.tiktokPaymentData.length > 0) {
    configTokenData.tiktokPaymentData.forEach((item) => {
      configTokenDataModel.tiktokPaymentList.push({
        bankAccount: {
          bankAccountId: item.bankAccountId ? item.bankAccountId : 0,
          inputValidationError: false,
        },
        tiktokPaymentMethod: item.tiktokPaymentMethod ? item.tiktokPaymentMethod : "-",
      });
    });
  }

  return configTokenDataModel;
}
function ConvertToShopeeUpdateConfigData(tokenConfigData) {
  const tokenConfigDataModel = {
    shopId: tokenConfigData.shopId,
    config: {
      allocationItemId: GetAllocationItemId(tokenConfigData.allocationItemId),
      documentNumberConfigType: tokenConfigData.documentNumberConfigType,
      peakContactId: tokenConfigData.contact.id,
      shippingAccountId: tokenConfigData.shippingAccount.id,
      promotionAccountId: tokenConfigData.promotionAccount.id,
      productAccountId: tokenConfigData.productAccount.id,
      productConfigType: tokenConfigData.isConnectPeak
        ? tokenConfigData.productConfigType.id
        : Enums.ProductConfigType.None,
      shippingVatType: tokenConfigData.shippingVatType.id,
      shopeePaymentData: [],
      triggerOrderStatus: tokenConfigData.triggerOrderStatus.id,
    },
  };

  if (tokenConfigData.shopeePaymentList && tokenConfigData.shopeePaymentList.length > 0) {
    tokenConfigData.shopeePaymentList.forEach((item) => {
      tokenConfigDataModel.config.shopeePaymentData.push({
        bankAccountId: item.bankAccount.bankAccountId,
        shopeePaymentMethod: item.shopeePaymentMethod,
      });
    });
  }

  return tokenConfigDataModel;
}
function GetAllocationItemId(allocationItemIdList) {
  let allocationItemId = 0;
  if (allocationItemIdList && allocationItemIdList.length > 0) {
    allocationItemIdList.forEach((item) => {
      allocationItemId = item.id;
      return allocationItemId;
    });
  }
  return allocationItemId;
}
function ConvertToLazadaUpdateConfigData(tokenConfigData) {
  const tokenConfigDataModel = {
    sellerId: tokenConfigData.sellerId,
    config: {
      allocationItemId: GetAllocationItemId(tokenConfigData.allocationItemId),
      documentNumberConfigType: tokenConfigData.documentNumberConfigType,
      peakContactId: tokenConfigData.contact.id,
      shippingAccountId: tokenConfigData.isShippeeFeeSetting ? tokenConfigData.shippingAccount.id : 0,
      promotionAccountId: tokenConfigData.promotionAccount.id,
      productAccountId: tokenConfigData.productAccount.id,
      productConfigType: tokenConfigData.isConnectPeak
        ? tokenConfigData.productConfigType.id
        : Enums.ProductConfigType.None,
      shippingVatType: tokenConfigData.shippingVatType.id,
      lazadaPaymentData: [],
      triggerOrderStatus: tokenConfigData.triggerOrderStatus.id,
    },
  };

  if (tokenConfigData.lazadaPaymentList && tokenConfigData.lazadaPaymentList.length > 0) {
    tokenConfigData.lazadaPaymentList.forEach((item) => {
      tokenConfigDataModel.config.lazadaPaymentData.push({
        bankAccountId: item.bankAccount.bankAccountId,
        lazadaPaymentMethod: item.lazadaPaymentMethod,
      });
    });
  }

  return tokenConfigDataModel;
}
function ConvertToTiktokUpdateConfigData(tokenConfigData) {
  const tokenConfigDataModel = {
    sellerId: tokenConfigData.sellerId,
    config: {
      allocationItemId: GetAllocationItemId(tokenConfigData.allocationItemId),
      documentNumberConfigType: tokenConfigData.documentNumberConfigType,
      peakContactId: tokenConfigData.contact.id,
      shippingAccountId: tokenConfigData.isShippeeFeeSetting ? tokenConfigData.shippingAccount.id : 0,
      promotionAccountId: tokenConfigData.promotionAccount.id,
      productAccountId: tokenConfigData.productAccount.id,
      productConfigType: tokenConfigData.isConnectPeak
        ? tokenConfigData.productConfigType.id
        : Enums.ProductConfigType.None,
      shippingVatType: tokenConfigData.shippingVatType.id,
      tiktokPaymentData: [],
      triggerOrderStatus: tokenConfigData.triggerOrderStatus.id,
    },
  };

  if (tokenConfigData.tiktokPaymentList && tokenConfigData.tiktokPaymentList.length > 0) {
    tokenConfigData.tiktokPaymentList.forEach((item) => {
      tokenConfigDataModel.config.tiktokPaymentData.push({
        bankAccountId: item.bankAccount.bankAccountId,
        tiktokPaymentMethod: item.tiktokPaymentMethod,
      });
    });
  }

  return tokenConfigDataModel;
}
function ConvertToSkuTemplateModelList(_skuTemplateModelList) {
  let skuTemplateModelList = [];

  if (_skuTemplateModelList && _skuTemplateModelList.length > 0) {
    _skuTemplateModelList.forEach((item) => {
      skuTemplateModelList.push({
        id: item.id,
        isActive: item.isActive,
        name: item.name,
        skuType: item.skuType,
        logoUrl: merchantHelper.GetLogoUrlSku(item.skuType),
      });
    });
  }
  return skuTemplateModelList;
}
function ConvertToSettingProductModel(_settingProductModel) {
  let settingProductModel = {
    id: 0,
    isCanNegative: false,
    isCalculateCost: true,
    isEditCalculateCost: true,
    isCalculateLot: true,
  };
  if (_settingProductModel) {
    settingProductModel.id = _settingProductModel.id;
    settingProductModel.isCanNegative = _settingProductModel.isCanNegative;
    settingProductModel.isCalculateCost = _settingProductModel.isCalculateCost;
    settingProductModel.isEditCalculateCost = _settingProductModel.isEditCalculateCost;
    settingProductModel.isCalculateLot = _settingProductModel.isCalculateLot;
  }
  return settingProductModel;
}
function ConvertToQrPaymentSetting(qrPaymentSetting) {
  let qrPaymentSettingModel = null;

  if (qrPaymentSetting) {
    qrPaymentSettingModel = {
      createDateTime: qrPaymentSetting.createDateTime,
      createUserId: qrPaymentSetting.createUserId,
      id: qrPaymentSetting.id,
      merchantId: qrPaymentSetting.merchantId,
      qrPaymentTypeId: qrPaymentSetting.qrPaymentTypeId,
      updateDateTime: qrPaymentSetting.updateDateTime,
      updateUserId: qrPaymentSetting.updateUserId,
      paySolutionPaymentModel: qrPaymentSetting.paySolutionPaymentModel
        ? GetPaySolutionsPaymentModel(qrPaymentSetting.paySolutionPaymentModel)
        : null,
      qrPaymentCodeModel: qrPaymentSetting.qrPaymentCodeModel,
      scbQRPaymentCodeModel: qrPaymentSetting.scbQRPaymentCodeModel
        ? GetScbQRPaymentModel(qrPaymentSetting.scbQRPaymentCodeModel)
        : null,
      bayQRPaymentCodeModel: qrPaymentSetting.bayQRPaymentCodeModel
        ? GetBayQRPaymentModel(qrPaymentSetting.bayQRPaymentCodeModel)
        : null,
      bblQRPaymentCodeModel: qrPaymentSetting.bblQRPaymentCodeModel
        ? GetBblQRPaymentModel(qrPaymentSetting.bblQRPaymentCodeModel)
        : null,
      beamPaymentModel: qrPaymentSetting.beamPaymentModel
        ? GetBeamPaymentModel(qrPaymentSetting.beamPaymentModel)
        : null,
      chillPayPaymentModel: qrPaymentSetting.chillPayPaymentCodeModel
        ? GetChillPayPaymentModel(qrPaymentSetting.chillPayPaymentCodeModel)
        : null,
    };
  }

  return qrPaymentSettingModel;
}
function GetScbQRPaymentModel(scbQRPayment) {
  let scbQRPaymentCodeModel = null;

  if (scbQRPayment) {
    scbQRPaymentCodeModel = {
      billerId: scbQRPayment.billerId,
      prefix: scbQRPayment.prefix,
      updateDateTime: scbQRPayment.updateDateTime,
      userId: scbQRPayment.userId,
    };

    const settingSCBQRPaymentCodeModel = scbQRPayment.settingSCBQRPaymentCodeModel;
    if (settingSCBQRPaymentCodeModel) {
      scbQRPaymentCodeModel.settingSCBQRPaymentCodeModel = {
        accountId: settingSCBQRPaymentCodeModel.accountId,
        bankAccountId: settingSCBQRPaymentCodeModel.bankAccountId,
        bankAccountTypeId: settingSCBQRPaymentCodeModel.bankAccountTypeId,
        bankNumber: settingSCBQRPaymentCodeModel.bankNumber,
        bankReferenceTypeId: settingSCBQRPaymentCodeModel.bankReferenceTypeId,
        bankTypeId: settingSCBQRPaymentCodeModel.bankTypeId,
        isAcceptMultiplePayment: settingSCBQRPaymentCodeModel.isAcceptMultiplePayment,
        isAutoCreateReceipt:
          settingSCBQRPaymentCodeModel.isAutoCreateReceipt == null
            ? false
            : settingSCBQRPaymentCodeModel.isAutoCreateReceipt,
        isAutoCreateTaxInvoiceReceipt:
          settingSCBQRPaymentCodeModel.isAutoCreateTaxInvoiceReceipt == null
            ? false
            : settingSCBQRPaymentCodeModel.isAutoCreateTaxInvoiceReceipt,
        isAutoUpdatePayment: settingSCBQRPaymentCodeModel.isAutoUpdatePayment,
      };
    }
  }

  return scbQRPaymentCodeModel;
}
function GetBayQRPaymentModel(bayQRPayment) {
  let bayQRPaymentCodeModel = null;

  if (bayQRPayment) {
    bayQRPaymentCodeModel = {
      billerId: bayQRPayment.billerId,
      updateDateTime: bayQRPayment.updateDateTime,
      userId: bayQRPayment.userId,
    };

    const settingBayQRPaymentCodeModel = bayQRPayment.settingBayQRPaymentCodeModel;
    if (settingBayQRPaymentCodeModel) {
      bayQRPaymentCodeModel.settingBayQRPaymentCodeModel = {
        accountId: settingBayQRPaymentCodeModel.accountId,
        bankAccountId: settingBayQRPaymentCodeModel.bankAccountId,
        bankAccountTypeId: settingBayQRPaymentCodeModel.bankAccountTypeId,
        bankNumber: settingBayQRPaymentCodeModel.bankNumber,
        bankReferenceTypeId: settingBayQRPaymentCodeModel.bankReferenceTypeId,
        bankTypeId: settingBayQRPaymentCodeModel.bankTypeId,
        isAcceptMultiplePayment: settingBayQRPaymentCodeModel.isAcceptMultiplePayment,
        isAutoCreateReceipt:
          settingBayQRPaymentCodeModel.isAutoCreateReceipt == null
            ? false
            : settingBayQRPaymentCodeModel.isAutoCreateReceipt,
        isAutoCreateTaxInvoiceReceipt:
          settingBayQRPaymentCodeModel.isAutoCreateTaxInvoiceReceipt == null
            ? false
            : settingBayQRPaymentCodeModel.isAutoCreateTaxInvoiceReceipt,
        isAutoUpdatePayment: settingBayQRPaymentCodeModel.isAutoUpdatePayment,
      };
    }
  }

  return bayQRPaymentCodeModel;
}
function GetBblQRPaymentModel(bblQRPayment) {
  let bblQRPaymentCodeModel = null;

  if (bblQRPayment) {
    bblQRPaymentCodeModel = {
      billerId: bblQRPayment.billerId,
      updateDateTime: bblQRPayment.updateDateTime,
      userId: bblQRPayment.userId,
    };

    const settingBblQRPaymentCodeModel = bblQRPayment.settingBblQRPaymentCodeModel;
    if (settingBblQRPaymentCodeModel) {
      bblQRPaymentCodeModel.settingBblQRPaymentCodeModel = {
        accountId: settingBblQRPaymentCodeModel.accountId,
        bankAccountId: settingBblQRPaymentCodeModel.bankAccountId,
        bankAccountTypeId: settingBblQRPaymentCodeModel.bankAccountTypeId,
        bankNumber: settingBblQRPaymentCodeModel.bankNumber,
        bankReferenceTypeId: settingBblQRPaymentCodeModel.bankReferenceTypeId,
        bankTypeId: settingBblQRPaymentCodeModel.bankTypeId,
        isAcceptMultiplePayment: settingBblQRPaymentCodeModel.isAcceptMultiplePayment,
        isAutoCreateReceipt:
          settingBblQRPaymentCodeModel.isAutoCreateReceipt == null
            ? false
            : settingBblQRPaymentCodeModel.isAutoCreateReceipt,
        isAutoCreateTaxInvoiceReceipt:
          settingBblQRPaymentCodeModel.isAutoCreateTaxInvoiceReceipt == null
            ? false
            : settingBblQRPaymentCodeModel.isAutoCreateTaxInvoiceReceipt,
        isAutoUpdatePayment: settingBblQRPaymentCodeModel.isAutoUpdatePayment,
      };
    }
  }

  return bblQRPaymentCodeModel;
}
function GetChillPayPaymentModel(chillPayPayment) {
  let chillPayPaymentModel = null;

  if (chillPayPayment) {
    chillPayPaymentModel = {
      apiKey: chillPayPayment.apiKey,
      chillPayMerchantCode: chillPayPayment.chillPayMerchantCode,
      paymentChannel: chillPayPayment.paymentChannel,
      md5Key: chillPayPayment.md5Key,
      updateDateTime: chillPayPayment.updateDateTime,
      userId: chillPayPayment.userId,
    };

    const settingPaymentConfigModel = chillPayPayment.settingPaymentConfigModel;
    if (settingPaymentConfigModel) {
      chillPayPaymentModel.settingPaymentConfigModel = {
        accountId: settingPaymentConfigModel.accountId,
        bankAccountId: settingPaymentConfigModel.bankAccountId,
        bankAccountTypeId: settingPaymentConfigModel.bankAccountTypeId,
        bankNumber: settingPaymentConfigModel.bankNumber,
        bankReferenceTypeId: settingPaymentConfigModel.bankReferenceTypeId,
        bankTypeId: settingPaymentConfigModel.bankTypeId,
        isAcceptMultiplePayment: settingPaymentConfigModel.isAcceptMultiplePayment,
        isAutoCreateReceipt:
          settingPaymentConfigModel.isAutoCreateReceipt == null ? true : settingPaymentConfigModel.isAutoCreateReceipt,
        isAutoCreateTaxInvoiceReceipt:
          settingPaymentConfigModel.isAutoCreateTaxInvoiceReceipt == null
            ? true
            : settingPaymentConfigModel.isAutoCreateTaxInvoiceReceipt,
        isAutoUpdatePayment: settingPaymentConfigModel.isAutoUpdatePayment,
      };
    }
  }

  return chillPayPaymentModel;
}
function GetBeamPaymentModel(beamPayment) {
  let beamPaymentModel = null;

  if (beamPayment) {
    beamPaymentModel = {
      apiKey: beamPayment.apiKey,
      beamMerchantId: beamPayment.beamMerchantId,
      secretKey: beamPayment.secretKey,
      updateDateTime: beamPayment.updateDateTime,
      userId: beamPayment.userId,
    };

    const settingPaymentConfigModel = beamPayment.settingPaymentConfigModel;
    if (settingPaymentConfigModel) {
      beamPaymentModel.settingPaymentConfigModel = {
        accountId: settingPaymentConfigModel.accountId,
        bankAccountId: settingPaymentConfigModel.bankAccountId,
        bankAccountTypeId: settingPaymentConfigModel.bankAccountTypeId,
        bankNumber: settingPaymentConfigModel.bankNumber,
        bankReferenceTypeId: settingPaymentConfigModel.bankReferenceTypeId,
        bankTypeId: settingPaymentConfigModel.bankTypeId,
        isAcceptMultiplePayment: settingPaymentConfigModel.isAcceptMultiplePayment,
        isAutoCreateReceipt:
          settingPaymentConfigModel.isAutoCreateReceipt == null ? true : settingPaymentConfigModel.isAutoCreateReceipt,
        isAutoCreateTaxInvoiceReceipt:
          settingPaymentConfigModel.isAutoCreateTaxInvoiceReceipt == null
            ? true
            : settingPaymentConfigModel.isAutoCreateTaxInvoiceReceipt,
        isAutoUpdatePayment: settingPaymentConfigModel.isAutoUpdatePayment,
      };
    }
  }

  return beamPaymentModel;
}
function GetPaySolutionsPaymentModel(paySolutionsPayment) {
  let paySolutionsPaymentModel = null;

  if (paySolutionsPayment) {
    paySolutionsPaymentModel = {
      apiKey: paySolutionsPayment.apiKey,
      paySolutionMerchantId: paySolutionsPayment.paySolutionMerchantId,
      secretKey: paySolutionsPayment.secretKey,
      updateDateTime: paySolutionsPayment.updateDateTime,
      userId: paySolutionsPayment.userId,
    };

    const settingPaymentConfigModel = paySolutionsPayment.settingPaymentConfigModel;
    if (settingPaymentConfigModel) {
      paySolutionsPaymentModel.settingPaymentConfigModel = {
        accountId: settingPaymentConfigModel.accountId,
        bankAccountId: settingPaymentConfigModel.bankAccountId,
        bankAccountTypeId: settingPaymentConfigModel.bankAccountTypeId,
        bankNumber: settingPaymentConfigModel.bankNumber,
        bankReferenceTypeId: settingPaymentConfigModel.bankReferenceTypeId,
        bankTypeId: settingPaymentConfigModel.bankTypeId,
        isAcceptMultiplePayment: settingPaymentConfigModel.isAcceptMultiplePayment,
        isAutoCreateReceipt:
          settingPaymentConfigModel.isAutoCreateReceipt == null ? true : settingPaymentConfigModel.isAutoCreateReceipt,
        isAutoCreateTaxInvoiceReceipt:
          settingPaymentConfigModel.isAutoCreateTaxInvoiceReceipt == null
            ? true
            : settingPaymentConfigModel.isAutoCreateTaxInvoiceReceipt,
        isAutoUpdatePayment: settingPaymentConfigModel.isAutoUpdatePayment,
      };
    }
  }

  return paySolutionsPaymentModel;
}
function ValidateTemplateModel(userTemplate) {
  let isValidate = true;

  if (!userTemplate.firstName.value || userTemplate.firstName.validateError) {
    isValidate = false;
    userTemplate.firstName.validateError = true;
  } else {
    userTemplate.firstName.validateError = false;
  }

  if (!userTemplate.lastName.value || userTemplate.lastName.validateError) {
    isValidate = false;
    userTemplate.lastName.validateError = true;
  } else {
    userTemplate.lastName.validateError = false;
  }

  if (!userTemplate.phone.value) {
    isValidate = false;
    userTemplate.phone.validateError = true;
  } else {
    userTemplate.phone.validateError = false;
  }

  if (userTemplate.department.value.value == 0) {
    if (!userTemplate.departmentOther.value || userTemplate.departmentOther.validateError) {
      isValidate = false;
      userTemplate.departmentOther.validateError = true;
    } else {
      userTemplate.departmentOther.validateError = false;
    }
  }

  if (userTemplate.position.value.value == 0) {
    if (!userTemplate.positionOther.value || userTemplate.positionOther.validateError) {
      isValidate = false;
      userTemplate.positionOther.validateError = true;
    } else {
      userTemplate.positionOther.validateError = false;
    }
  }

  return isValidate;
}

function ConvertToMerchantList(merchantListRaw) {
  let merchantList = [];
  if (merchantListRaw && merchantListRaw.length > 0) {
    for (const merchantRaw of merchantListRaw) {
      merchantList.push({
        merchantId: merchantRaw.merchantId,
        merchantName: merchantRaw.merchantName,
        merchantNameEng: merchantRaw.merchantNameEng,
        merchantNameTh: merchantRaw.merchantNameTh,
        merchantBranchCode: merchantRaw.merchantBranchCode,
        isSample: merchantRaw.isSample,
        merchantTaxId: merchantRaw.merchantTaxId,
      });
    }
  }
  return merchantList;
}
export default {
  GetSettingTransactionDueDate(settingTransactionDueDateRawList) {
    return GetSettingTransactionDueDate(settingTransactionDueDateRawList);
  },
  GetSettingTransactionRemark(settingTransactionRemarkRawList) {
    return GetSettingTransactionRemark(settingTransactionRemarkRawList);
  },
  GetSettingTransactionNumber(settingTransactionNumberRawList) {
    return GetSettingTransactionNumber(settingTransactionNumberRawList);
  },
  GetMerchantDetail(settingMerchantDetail) {
    return GetMerchantDetail(settingMerchantDetail);
  },
  GetMerchantAddressList(settingMerchantAddressList) {
    return GetMerchantAddressList(settingMerchantAddressList);
  },
  DoGetUserRoleDetailByUserId(userDetail) {
    return DoGetUserRoleDetailByUserId(userDetail);
  },
  GetMerchantSettingApiPartnerUserToken(apiPartnerUserToken) {
    return GetMerchantSettingApiPartnerUserToken(apiPartnerUserToken);
  },
  GetOnlineViewPublicFormatSetting(getOnlineViewPublicFormatSetting) {
    return GetOnlineViewPublicFormatSetting(getOnlineViewPublicFormatSetting);
  },
  ConvertToETaxConnectSetting(eTaxConnectSetting) {
    return ConvertToETaxConnectSetting(eTaxConnectSetting);
  },
  ConvertToOnboardingLog(onboardingLog) {
    return ConvertToOnboardingLog(onboardingLog);
  },
  ConvertToUserTemplateModel(userTemplate) {
    return ConvertToUserTemplateModel(userTemplate);
  },
  ConvertToConfigTokenPage365(configToken) {
    return ConvertToConfigTokenPage365(configToken);
  },
  ConvertToTokenDataBentoWeb(configToken) {
    return ConvertToTokenDataBentoWeb(configToken);
  },
  ConvertToTokenConfigDataBentoWeb(configData) {
    return ConvertToTokenConfigDataBentoWeb(configData);
  },
  ConvertToTokenDataPage365(tokenData) {
    return ConvertToTokenDataPage365(tokenData);
  },
  ConvertToTokenConfigDataPage365(configToken) {
    return ConvertToTokenConfigDataPage365(configToken);
  },
  ConvertToTokenConfigDataPage365Request(configToken) {
    return ConvertToTokenConfigDataPage365Request(configToken);
  },
  ConvertToBentoWebUpdateConfigData(configToken) {
    return ConvertToBentoWebUpdateConfigData(configToken);
  },
  ConvertToTokenDataLineMyShop(tokenData) {
    return ConvertToTokenDataLineMyShop(tokenData);
  },
  ConvertToTokenConfigDataLineMyShop(configToken, contact) {
    return ConvertToTokenConfigDataLineMyShop(configToken, contact);
  },
  ConvertToLineMyShopUpdateConfigData(configToken) {
    return ConvertToLineMyShopUpdateConfigData(configToken);
  },
  ConvertToTokenDataShopee(tokenData) {
    return ConvertToTokenDataShopee(tokenData);
  },
  ConvertToTokenDataLazada(tokenData) {
    return ConvertToTokenDataLazada(tokenData);
  },
  ConvertToTokenDataTiktok(tokenData) {
    return ConvertToTokenDataTiktok(tokenData);
  },
  ConvertToClientUserDataAPIOwnUse(tokenData) {
    return ConvertToClientUserDataAPIOwnUse(tokenData);
  },
  ConvertToPartnerUserTokenTable(tokenData) {
    return ConvertToPartnerUserTokenTable(tokenData);
  },
  ConvertToPartnerUserTokenMonitor(tokenMonitorData) {
    return ConvertToPartnerUserTokenMonitor(tokenMonitorData);
  },
  ConvertToValidateClientUserAPIOwnUse(tokenData) {
    return ConvertToValidateClientUserAPIOwnUse(tokenData);
  },
  ConvertToTokenConfigDataShopee(configToken, contact) {
    return ConvertToTokenConfigDataShopee(configToken, contact);
  },
  ConvertToTokenConfigDataLazada(configToken, contact) {
    return ConvertToTokenConfigDataLazada(configToken, contact);
  },
  ConvertToTokenConfigDataTiktok(configToken, contact) {
    return ConvertToTokenConfigDataTiktok(configToken, contact);
  },
  ConvertToShopeeUpdateConfigData(configToken) {
    return ConvertToShopeeUpdateConfigData(configToken);
  },
  ConvertToLazadaUpdateConfigData(configToken) {
    return ConvertToLazadaUpdateConfigData(configToken);
  },
  ConvertToTiktokUpdateConfigData(configToken) {
    return ConvertToTiktokUpdateConfigData(configToken);
  },
  ConvertToSkuTemplateModelList(skuTemplateModelList) {
    return ConvertToSkuTemplateModelList(skuTemplateModelList);
  },
  ConvertToSettingProductModel(settingProductModel) {
    return ConvertToSettingProductModel(settingProductModel);
  },
  ConvertToQrPaymentSetting(qrPaymentSetting) {
    return ConvertToQrPaymentSetting(qrPaymentSetting);
  },
  ValidateTemplateModel(userTemplate) {
    return ValidateTemplateModel(userTemplate);
  },
  ConvertToMerchantList(merchantList) {
    return ConvertToMerchantList(merchantList);
  },
};
